import { setParams } from 'utils/urlParams';
import { List } from '../types';

export const createEmailListIdParams = (list: Partial<List>, url: string) => {
  const emailListId = list && list.id ? list.id.toString() : '';
  return setParams(url, { emailListId });
};
